/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserSettingDto } from '../../models/user-setting-dto';

export interface UserSettingControllerGetMe$Params {
}

export function userSettingControllerGetMe(http: HttpClient, rootUrl: string, params?: UserSettingControllerGetMe$Params, context?: HttpContext): Observable<StrictHttpResponse<UserSettingDto>> {
  const rb = new RequestBuilder(rootUrl, userSettingControllerGetMe.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserSettingDto>;
    })
  );
}

userSettingControllerGetMe.PATH = '/api/user-setting';
